import { render, staticRenderFns } from "./TheSelection.vue?vue&type=template&id=f9ab1fb0"
import script from "./TheSelection.vue?vue&type=script&lang=js"
export * from "./TheSelection.vue?vue&type=script&lang=js"
import style0 from "./TheSelection.vue?vue&type=style&index=0&id=f9ab1fb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports